import { decimalLikeToDecimal } from '@snap-types/schemas/decimal';
import { emptyishToNull } from '@snap-types/schemas/emptyish';
import { z } from 'zod/v4';

export const nullableString = z.preprocess(
  emptyishToNull,
  z.string().nullish(),
);

export const nullableDecimal = z.preprocess(
  emptyishToNull,
  decimalLikeToDecimal.nullish(),
);

export const decimal = z.preprocess(emptyishToNull, decimalLikeToDecimal);

export const nullableInt = z.preprocess(
  emptyishToNull,
  z.coerce.number().int().nullish(),
);

export const requiredInt = z.preprocess(
  emptyishToNull,
  z.coerce.number().int(),
);

export const yesNoBoolean = z.preprocess((value: unknown) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (!normalized) {
      return null;
    }

    if (['yes', 'y', 'true', 't', '1'].includes(normalized)) {
      return true;
    }

    if (['no', 'n', 'false', 'f', '0'].includes(normalized)) {
      return false;
    }
  }

  return value;
}, z.boolean().nullish());
